import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
export class LCDQueryClient {
  constructor({
    requestClient
  }) {
    _defineProperty(this, "req", void 0);
    this.req = requestClient;
    this.params = this.params.bind(this);
    this.stakingContracts = this.stakingContracts.bind(this);
    this.governanceContracts = this.governanceContracts.bind(this);
  }
  /* Params */
  async params(_params = {}) {
    const endpoint = `juno/cwhooks/v1/params`;
    return await this.req.get(endpoint);
  }
  /* StakingContracts */
  async stakingContracts(_params = {}) {
    const endpoint = `juno/cwhooks/v1/staking_contracts`;
    return await this.req.get(endpoint);
  }
  /* GovernanceContracts */
  async governanceContracts(_params = {}) {
    const endpoint = `juno/cwhooks/v1/governance_contracts`;
    return await this.req.get(endpoint);
  }
}